
function initializeMap() {
    window.map = new ym.map.CMap(config.Container, config.Options);
}
